"use client"
import Image from "next/image"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { BlogPost } from "@/types/blog"
import { ArrowRightIcon } from "@/icons"
import tailwindConfig from "../../../../tailwind.config"
import { cn } from "@/lib/utils"
import { useTranslate } from "@tolgee/react"

interface BlogCardProps {
  post: BlogPost
  index: number
}

export function BlogCard({ post, index }: BlogCardProps) {
  const cardClasses = cn(
    "group block border border-[#373737] p-1 rounded-sm relative",
    index > 0 && "hidden lg:block"
  );

  let CardWrapper: React.ElementType = 'div';
  let wrapperProps: { href?: string; className: string } = { className: cardClasses };

  if (post.href) {
    if (post.href.startsWith("http")) {
      CardWrapper = 'a';
      wrapperProps.href = post.href;
    } else {
      CardWrapper = LocalizedClientLink;
      wrapperProps.href = post.href;
    }
  }

  return (
    <CardWrapper {...wrapperProps}>
      <CardContent post={post} />
    </CardWrapper>
  );
}


const CardContent = ({ post }: { post: BlogPost }) => {
  const { t } = useTranslate()
  return <>
    <div className="relative overflow-hidden rounded-xs h-full">
      <Image
        src={decodeURIComponent(post.image)}
        alt={post.excerpt}
        width={467}
        height={472}
        className="object-cover h-[100%] m-auto rounded-xl scale-75"
        priority
      />
    </div>
    <div className="p-4 bg-tertiary text-tertiary absolute bottom-0 left-1 lg:opacity-0 group-hover:opacity-100 transition-all duration-300 rounded-b-xs w-[calc(100%-8px)]">
      <h3 className="heading-sm">{post.title}</h3>
      <p className="text-md line-clamp-2">{post.excerpt}</p>
      {post.href && <div className="flex items-center gap-4 uppercase label-md mt-[26px]">
        {t("blog_card.read_more")}{" "}
        <ArrowRightIcon
          size={20}
          color={tailwindConfig.theme.extend.colors.tertiary}
        />
      </div>}
    </div>
  </>
}